<template lang="pug">
AppDialog.vue-reports-notes-dialog(
  :title="header"
  append-to-body
  size="medium"
  :show="show"
  @close="close"
)
  .notes(
    v-for="(note, index) in notes"
    :key="index"
  )
    .project_name
      span.strong {{ projectName }}
    span.time.text-lighter {{ note.recorded_at | formatDateTime }}
    p.break-word {{ note.description | stripHTML }}

  template(slot="footer")
    button.btn.btn-default(@click="close") Close
</template>
<script>
export default {
  name: 'NotesDialog',
  props: {
    notes: {
      type: Array,
    },
    show: {
      type: Boolean,
      default: false,
    },
    projectName: {
      type: String,
    },
  },
  computed: {
    header() {
      return `${this.notes.length} Notes`;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
